import React__default, { useState, useEffect } from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { Button } from '../../Button/index.js';
import useFormat from '../../../helpers/use-format.js';
import { Input } from '../../Input/index.js';
import { Checkbox } from '../../Checkbox/index.js';
import '../../Slider/context.js';
import '../../Slider/handle.js';
import '../../Slider/highlight.js';
import '../../Slider/track.js';
import '../../Slider/slider.js';
import { RangeSlider } from '../../Slider/range-slider.js';
import { RangeSliderNonLinear } from '../../Slider/range-slider-non-linear.js';
import { FilterContainer } from '../FilterContainer/index.js';
import styles from 'ui-components/FilterMenu/FilterPrice.scss';

var FilterPrice = function FilterPrice(_ref) {
  var openFilter = _ref.openFilter,
    setOpenFilter = _ref.setOpenFilter,
    minPrice = _ref.minPrice,
    maxPrice = _ref.maxPrice,
    priceRange = _ref.priceRange,
    setPriceRange = _ref.setPriceRange,
    loading = _ref.loading,
    usePoints = _ref.usePoints,
    label = _ref.label,
    balance = _ref.balance,
    ChevronIcon = _ref.ChevronIcon,
    nonLinearSlider = _ref.nonLinearSlider,
    exponentiation = _ref.exponentiation;
  var _useFormat = useFormat(),
    formatPoints = _useFormat.formatPoints,
    formatPrice = _useFormat.formatPrice;
  var t = useTranslate();
  var _useState = useState({
      min: String(priceRange.min),
      max: String(priceRange.max)
    }),
    price = _useState[0],
    setPrice = _useState[1];
  useEffect(function () {
    setPrice({
      min: String(priceRange.min),
      max: String(priceRange.max)
    });
  }, [priceRange]);
  var noop = function noop() {};
  var submitPriceRange = function submitPriceRange() {
    if (minPrice === maxPrice) {
      setPrice({
        min: String(priceRange.min),
        max: String(priceRange.max)
      });
    }
    var min = price.min ? Number.parseInt(price.min, 10) : minPrice;
    var max = price.max ? Number.parseInt(price.max, 10) : maxPrice;
    var range = {
      min: min > minPrice && min < maxPrice ? min : minPrice,
      max: max > minPrice && max < maxPrice ? max : maxPrice
    };
    setPriceRange(range, true);
  };
  var reset = function reset() {
    setPriceRange({
      min: minPrice,
      max: maxPrice
    });
  };
  var showResetButton = priceRange.min !== minPrice || priceRange.max !== maxPrice;
  var showBalanceFilter = typeof balance !== "undefined" && balance > minPrice && balance < maxPrice;
  var activePriceFilterValue = priceRange.min !== minPrice || priceRange.max !== maxPrice ? priceRange.min + " - " + priceRange.max : undefined;
  return /*#__PURE__*/React__default.createElement(FilterContainer, {
    openFilter: openFilter,
    setOpenFilter: setOpenFilter,
    filterName: label.charAt(0).toUpperCase() + label.slice(1),
    ChevronIcon: ChevronIcon,
    activeFilterValue: activePriceFilterValue
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.body__top
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.subheader
  }, usePoints ? t("FILTER.FILTERMENU.FILTER_BY_POINTS", {
    pointsLabel: label
  }) : t("FILTER.FILTERMENU.FILTER_BY_PRICE")), showResetButton && /*#__PURE__*/React__default.createElement(Button, {
    disabled: loading,
    className: styles.reset_button,
    onClick: reset
  }, t("FILTER.FILTERMENU.RESET_PRICE"))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.price_slider,
    onTransitionEnd: function onTransitionEnd(e) {
      e.stopPropagation();
    }
  }, nonLinearSlider === true ? /*#__PURE__*/React__default.createElement(RangeSliderNonLinear, {
    exponentiation: exponentiation,
    stepSize: 0.1,
    variant: "small",
    value: priceRange,
    minValue: minPrice,
    maxValue: maxPrice,
    onChange: setPriceRange
  }) : /*#__PURE__*/React__default.createElement(RangeSlider, {
    variant: "small",
    value: priceRange,
    minValue: minPrice,
    maxValue: maxPrice,
    onChange: setPriceRange
  })), usePoints ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.price_slider__labels
  }, /*#__PURE__*/React__default.createElement("span", null, formatPoints(priceRange.min, label)), /*#__PURE__*/React__default.createElement("span", null, formatPoints(priceRange.max, label))) : /*#__PURE__*/React__default.createElement("div", {
    className: styles.price_slider__labels
  }, /*#__PURE__*/React__default.createElement("span", null, formatPrice(priceRange.min)), /*#__PURE__*/React__default.createElement("span", null, formatPrice(priceRange.max))), /*#__PURE__*/React__default.createElement("div", {
    className: styles.price_inputs
  }, /*#__PURE__*/React__default.createElement(Input, {
    className: styles.input,
    disabled: loading,
    label: t("FILTER.FILTERMENU.PRICE_FROM"),
    type: "number",
    min: "0",
    inputMode: "numeric",
    pattern: "[0-9]*",
    value: price.min,
    onBlur: submitPriceRange,
    onKeyUp: function onKeyUp(e) {
      if (e.key === "Enter") {
        submitPriceRange();
      }
    },
    onChange: function onChange(e) {
      setPrice({
        min: e.currentTarget.value,
        max: price.max
      });
    }
  }), /*#__PURE__*/React__default.createElement(Input, {
    className: styles.input,
    disabled: loading,
    type: "number",
    min: "0",
    inputMode: "numeric",
    pattern: "[0-9]*",
    label: t("FILTER.FILTERMENU.PRICE_TO"),
    value: price.max,
    onBlur: submitPriceRange,
    onKeyUp: function onKeyUp(e) {
      if (e.key === "Enter") {
        submitPriceRange();
      }
    },
    onChange: function onChange(e) {
      setPrice({
        min: price.min,
        max: e.currentTarget.value
      });
    }
  })), showBalanceFilter && typeof balance !== "undefined" && /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.balance, styles.value__boolean),
    onClick: function onClick() {
      var maxBalance = balance > maxPrice ? maxPrice : balance;
      setPriceRange({
        min: minPrice,
        max: priceRange.max === maxBalance ? maxPrice : maxBalance
      });
    }
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    className: styles.checkbox,
    value: priceRange.max === balance,
    onChange: noop
  }), /*#__PURE__*/React__default.createElement("span", null, t("FILTER.FILTERMENU.BALANCE_FILTER", {
    value: balance
  })))));
};

export { FilterPrice };
//# sourceMappingURL=index.js.map
